import { render, staticRenderFns } from "./StatementReport.vue?vue&type=template&id=2664b4e9&scoped=true"
import script from "./StatementReport.vue?vue&type=script&lang=js"
export * from "./StatementReport.vue?vue&type=script&lang=js"
import style0 from "./StatementReport.vue?vue&type=style&index=0&id=2664b4e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2664b4e9",
  null
  
)

export default component.exports